import { getESportWebUrl, getAdvantPlayUrl, OpenAdvantPlayProps } from '@/hooks/query/use-third-party-authorization';
import { checkUmBySportType } from '@/hooks/query/use-um-message';
import { modalService } from './modal.service';
import { windowService } from './jupiter/window-service';
import windowNameKeys from '@/constants/window-name-keys';
import { MarketLabel } from '@/types';
interface OpenESportProps {
	siteId?: string;
	umSource?: string;
	gameId?: string;
	market?: MarketLabel | null;
	leagueId?: number;
	matchId?: number;
	isDeepLink?: boolean;
	isApp?: boolean;
}
const showAdvantPlayError = (error: unknown) => {
	try {
		modalService.openMessageModal(error instanceof Error ? error.message : 'Error');
	} catch {
		// prevent modal error from cascading
	}
};

export const openAdvantPlay = (props: OpenAdvantPlayProps, token?: string) => {
	if (!window) return;

	if (props.isApp) {
		getAdvantPlayUrl(props, token)
			.then(url => { if (url) window.location.href = url; })
			.catch(showAdvantPlayError);
	} else {
		try {
			windowService.openWindow(windowNameKeys.ADVANTPLAY, 'about:blank', '_blank');
		} catch {
			// ignore if blank window fails to open
		}
		getAdvantPlayUrl(props, token)
			.then(url => {
				if (url) windowService.openWindow(windowNameKeys.ADVANTPLAY, url, '_blank');
			})
			.catch((error: unknown) => {
				windowService.closeWindow(windowNameKeys.ADVANTPLAY);
				showAdvantPlayError(error);
			});
	}
};

export const openESport = (openESportProps: OpenESportProps, token?: string, EnableEsportsDeeplink?: boolean) => {
	// if (!EnableEsportsDeeplink) {
	// 	location.href = '/lobby';
	// 	return;
	// }
	if (window) {
		const newWindow = openESportProps.isDeepLink || openESportProps.isApp ? null : window.open('about:blank', '_blank');
		checkUmBySportType(openESportProps.siteId as string, '43').then(data => {
			if (data.isUM) {
				if (!openESportProps.isDeepLink) {
					newWindow?.close();
				}
				modalService.openMessageModal(openESportProps.umSource ?? 'Under Maintenance');
			} else {
				getESportWebUrl(openESportProps, token).then(data => {
					if (openESportProps.isDeepLink || openESportProps.isApp) {
						window.location.href = data.data.Data ?? '';
						return;
					} else {
						if (newWindow) {
							newWindow.location = data.data.Data ?? '';
							newWindow.focus();
						}
					}
				});
			}
		})
	}
}